/**
 * @fileoverview Initial state for maker-checker module.
 *
 * @module store/modules/makerchecker/state
 *
 * Defines default state for approval workflow including
 * change lists, user authentication, and filter states.
 */

import { MakerCheckerState } from "./types";

const state: MakerCheckerState = {
  pendingChanges: [],
  completedChanges: [],
  userAuthentication: {},
  mainType: "",
  currentDepartment: "",
  activeLeftPane: "pending",
};

export default state;
